import { Link } from 'react-router-dom';
import { categories } from '@/mocks/videos';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                  <i className="ri-play-circle-fill text-background-50 text-lg"></i>
                </div>
                <span className="text-xl font-bold font-heading text-foreground-900">
                  桃子视频
                </span>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                免费高清在线影视平台，涵盖红桃、黑桃、桃花、红杏、糖心、豆花等多品类视频资源。每日更新热门电影、电视剧、综艺和纪录片。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">
                视频分类
              </h4>
              <ul className="space-y-2">
                {categories.slice(0, 6).map((cat) => (
                  <li key={cat.id}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">
                快速链接
              </h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                    首页
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                    关于我们
                  </Link>
                </li>
                <li>
                  <a href="#" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                    用户协议
                  </a>
                </li>
                <li>
                  <a href="#" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                    隐私政策
                  </a>
                </li>
                <li>
                  <a href="#" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                    版权声明
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">
                联系我们
              </h4>
              <ul className="space-y-2">
                <li className="flex items-start gap-2">
                  <i className="ri-mail-line text-foreground-500 mt-0.5 text-sm"></i>
                  <span className="text-sm text-foreground-600">contact@taozivideo.com</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-phone-line text-foreground-500 mt-0.5 text-sm"></i>
                  <span className="text-sm text-foreground-600">400-888-0000</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-map-pin-line text-foreground-500 mt-0.5 text-sm"></i>
                  <span className="text-sm text-foreground-600">北京市朝阳区建国路88号</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-10 pt-8 border-t border-background-200/70">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-xs text-foreground-500">
                &copy; {new Date().getFullYear()} 桃子视频 Taozivideo.com 版权所有 | 京ICP备2024000001号
              </p>
              <div className="flex items-center gap-4">
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 hover:bg-primary-100 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-foreground-600 text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 hover:bg-primary-100 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-foreground-600 text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 hover:bg-primary-100 transition-colors cursor-pointer" aria-label="抖音">
                  <i className="ri-tiktok-line text-foreground-600 text-sm"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}